import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10 text-center">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-accent-100">
          <i className="ri-error-warning-line text-3xl text-accent-600"></i>
        </div>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
          Pagina Nao Encontrada
        </h2>
        <p className="text-sm text-foreground-500 font-mono mb-4">{location.pathname}</p>
        <p className="text-foreground-600 text-sm mb-6">
          A pagina que voce procura nao existe ou foi movida.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i>
          Voltar ao Inicio
        </Link>
      </div>
    </div>
  );
}